import { defineStore } from "pinia";

export const useUserStore = defineStore('user',{

    state: () => {
        return {
            user:{
                id:"",
                clinicId:"",
                name:"",
                email:"",
                hasActiveSubscription: false,
                type:"",
                token:"",
                loggedIn:false,
                clinicName:"",
                clinicCodeName:"",
                unreadNotifications:0
            }
        }       
    },    
    persist:true,                                           
    getters: {        
        getUser(state) {                       
            return state.user;
        }
    },
    actions: {
        signIn(token) {
            this.user.token = token;
            this.user.loggedIn = true;                        
        },
        setUserCredendials(id, clinicId, name, email, type, clinicName, clinicCodeName, unreadNotifications, hasActiveSubscription) {
            this.user.id = id;
            this.user.clinicId = clinicId;
            this.user.name = name;
            this.user.email = email;
            this.user.type = type;
            this.user.clinicName = clinicName;
            this.user.clinicCodeName = clinicCodeName;
            this.user.unreadNotifications = unreadNotifications;
            this.user.hasActiveSubscription = hasActiveSubscription;
        },
        signOut() {
            this.user.token = "";
            this.user.loggedIn = false; 
        },
        readNotification() {
            this.user.unreadNotifications = this.user.unreadNotifications - 1;
        }        
    }
})     
    

